import apiClient from "../apiClient";
import { apiBaseUrl } from "../../config";

export const createCampaign = async (data) => {
  return apiClient
    .post(`${apiBaseUrl}/payment-collection-manager/campaign`, data, true)
    .then((response) => {
      return response;
    });
};

export const getCampaigns = async ({
  search = "",
  page = 1,
  limit = 10,
  filters = "",
  sort = "",
}) => {
  return apiClient
    .get(
      `${apiBaseUrl}/payment-collection-manager/campaign/search?limit=${limit}&page=${page}&q=wildCard~${search}${filters}&${
        sort || "field=created&order=-1"
      }`
    )
    .then((response) => {
      return response;
    });
};

export const getCampaignById = async (campaignId) => {
  return apiClient
    .get(`${apiBaseUrl}/payment-collection-manager/campaign/${campaignId}`)
    .then((response) => {
      return response;
    });
};

export const createPaymentBuilder = async (campaignId) => {
  return apiClient
    .post(
      `${apiBaseUrl}/payment-collection-manager/campaign/${campaignId}/payment-builder`
    )
    .then((response) => {
      return response;
    });
};

export const createLinkBuilder = async (campaignId) => {
  return apiClient
    .post(
      `${apiBaseUrl}/payment-collection-manager/campaign/${campaignId}/link-builder`
    )
    .then((response) => {
      return response;
    });
};

export const getNotifications = async ({
  limit = 10,
  page = 1,
  campaignId = "",
  search = "",
}) => {
  return apiClient
    .get(
      `${apiBaseUrl}/notifications/search?limit=${limit}&page=${page}&q=wildCard~${
        search ? `%20$AND%20email~${search}` : ""
      }%20$AND%20campaign_id~${campaignId}&field=created&order=-1`
    )
    .then((response) => {
      return response;
    });
};

export const sendNotifications = async () => {
  return apiClient.get(`${apiBaseUrl}/notifications/send`).then((response) => {
    return response;
  });
};

export const changeNotificationsDate = async (body) => {
  return apiClient
    .post(
      `${apiBaseUrl}/payment-collection-manager/campaign/date-changer`,
      body
    )
    .then((response) => {
      return response;
    });
};
